import { Http } from '../axios/interceptors'

export const allClientsByCompany = async (param) => Http('GET', `/Clients/GetByCompany?`, param)

export const getClient = async guid => Http('GET', `/Clients/Get?idClient=${guid}`)

export const createOrEditClient = async (body, id = null) => (id ? Http('PUT', `/Clients/Update`, null, body) : Http('POST', '/Clients/Create', null, body))

export const deleteClient = async guid => Http('DELETE', `/Clients/Delete?idClient=${guid}`)
